import { PopoverContentPosition } from "@/app/(components)/generics/Popover/PopoverContent";
import { TKey } from "@/app/translations/TKey";
import { HomePricingPeriod, HomePricingPeriodTab } from "@/app/types/home/HomePricing";
import { UCreditOffer } from "@/app/utils/UCreditOffer";
import { CreditOffer } from "@/app/vars/Credits";

export const HOME_PRICING_PERIODS: HomePricingPeriodTab[] = [
  { period: HomePricingPeriod.MONTHLY, labelKey: TKey.HOME_MEIDLY_PRICING_PERIOD_MONTHLY },
  { period: HomePricingPeriod.ANNUAL, labelKey: TKey.HOME_MEIDLY_PRICING_PERIOD_ANNUAL },
];

export const HOME_PRICING_PRO_FEATURES: TKey[] = [
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_TRIAL,
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_CHARACTERS,
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_QUESTION,
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_ROLLOVER,
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_IMPORTS,
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_RECORDING,
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_PROSPECTS,
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_CUSTOMERS,
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_INTEGRATIONS,
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_SUPPORT,
];

export const HOME_PRICING_CUSTOM_FEATURES: TKey[] = [
  TKey.HOME_MEIDLY_PRICING_CUSTOM_FEATURE_EVERYTHING,
  TKey.HOME_MEIDLY_PRICING_CUSTOM_FEATURE_VOLUME,
  TKey.HOME_MEIDLY_PRICING_CUSTOM_FEATURE_ONBOARDING,
  TKey.HOME_MEIDLY_PRICING_CUSTOM_FEATURE_SUPPORT,
];

export function fillPricingText(text: string, values: Record<string, string | number>): string {
  return Object.entries(values).reduce(
    (result, [key, value]) => result.replaceAll(`{{${key}}}`, String(value)),
    text,
  );
}

export const VOLUME_MENU_POSITION: PopoverContentPosition = {
  default: { top: "46px", right: "0px" },
};

export function buildProFeatureValues(lang: string): Record<string, string | number> {
  return {
    signupCredits: CreditOffer.SIGNUP_CREDITS,
    chars: UCreditOffer.formatCredits(CreditOffer.CHARACTERS_PER_CREDIT, lang),
    questionCredits: CreditOffer.QUESTION_CREDITS,
    months: CreditOffer.ROLLOVER_MONTHS,
    annualMonths: CreditOffer.ANNUAL_ROLLOVER_MONTHS,
  };
}
